<div style="background-color: #A00000; color: white;">
<app-page-breadcrumb [isModal]="isModal"
[pageInfo]="{title : 'Payment Details',buttonShowBtn : true,button :{title : '', url :'',icon : 'las la-times', color: 'light'}}"></app-page-breadcrumb>

</div>
<!-- <div class="modal-body card pt-3"> -->
<div class="modal-body card pt-3 !rounded-b-2xl overflow-hidden">
    <div class="mb-2">
        <div class="row clearfix m-2" [hidden]="dataLoading">
            <div class="col-lg-12 col-md-12 col-xl-12">
                <info-view [sourceData]="organizationData" [formData]="organizationFormData"></info-view>
            </div>
        </div>
        <div class="row clearfix text-center mt-2" [hidden]="dataLoading">
            <div class="col-12">
                <button [disabled]="loading"  (click)="close()" class="btn ml-1 btn-round btn-danger">Close</button>
            </div>
        </div>
        <app-page-loader [loading]="dataLoading"></app-page-loader>
    </div>
</div>
